module.exports = {"name":"Saison :season","name_med":":expansion Saison :season","name_long":":expansion Saison :season"};